import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const MobileInput = ({
  name,
  title,
  value,
  error,
  handleChange,
  placeholder,
  page,
  open,
  disabled,
}) => {
  const handleMobile = (value, data) => {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 16);
    handleChange({
      name: name,
      value: digitsOnly,
      country_code: data.countryCode,
    });
  };

  return (
    <div className={`  text-start`}>
      {title && (
        <label className="d-flex align-items-center fs-12 min-200 mb-1 form-label">
          <span className="required">{title}</span>
        </label>
      )}

      <PhoneInput
        key={open ? "open" : "closed"}
        country={"cm"}
        disableDropdown={true}
        countryCodeEditable={false}
        value={value}
        placeholder={placeholder}
        enableLongNumbers={false}
        onChange={handleMobile}
        inputProps={{
          name: name,
          required: true,
          autoFocus: false,
          maxLength: 16,
          disabled: disabled,
        }}
        inputclassName="w-100 no-country-code"
        onlyCountries={["cm"]}
      />
      <div style={page ? { height: "20px" } : {}} className="mb-1">
        <span className="fs-10 text-danger ps-3">{error}</span>
      </div>
    </div>
  );
};

MobileInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  page: PropTypes.string,
};

export default MobileInput;
